var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_905_7600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 6V8.5M8 10V10.0067",
    stroke: "#D42015",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33313 12.6664H12.6665C12.884 12.6648 13.0979 12.6101 13.2894 12.5069C13.4809 12.4038 13.6443 12.2553 13.7653 12.0745C13.8862 11.8937 13.9611 11.686 13.9834 11.4696C14.0057 11.2532 13.9747 11.0347 13.8931 10.833L9.1598 2.66635C9.0445 2.45795 8.87547 2.28424 8.6703 2.16328C8.46513 2.04231 8.23131 1.97852 7.99313 1.97852C7.75496 1.97852 7.52114 2.04231 7.31597 2.16328C7.1108 2.28424 6.94177 2.45795 6.82647 2.66635L2.09313 10.833C2.0131 11.0301 1.98136 11.2434 2.00057 11.4552C2.01978 11.667 2.08938 11.8712 2.20357 12.0506C2.31775 12.2301 2.47321 12.3796 2.65695 12.4867C2.8407 12.5938 3.0474 12.6554 3.2598 12.6664",
    stroke: "#D42015",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_905_7600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.59ffd1f6b4a870168b202264162def77.svg";
export { ForwardRef as ReactComponent };